import { Asset, AssetCollection } from '../../assets/Asset';

import { CategoryCollection, Category, category_sort } from '../../Categories';
import { Id_asset, Id_category, Id_location } from '../../api/Identifiers';
import { CssElement } from '../../css_utils';
import { get_state, did_any_change, State } from '../../redux/State';
import { Keys } from '../../redux/Datastore';
import { Cookie } from '../../Cookies';
import { dispatch_action, Dispatcher } from '../../redux/Dispatcher';
import { Action, Actions } from '../../redux/Actions';
import { Configuration } from '../../Configuration';

let expanded_categories: Id_category[] = []


export class UI {
    public static readonly id_menu_assets_header: string = 'menu_assets_header';
    public static readonly id_menu_assets_header_chevron: string = 'menu_assets_header_chevron';
    public static readonly id_menu_assets_content: string = 'menu_assets_content'
    public static readonly id_menu_assets_content_list: string = 'menu_assets_content_list'
    

    public static get menu_assets_container(): HTMLDivElement {
        return <HTMLDivElement>document.getElementById('menu_assets_container');

    }
    public static get menu_assets_header(): HTMLElement {
        return document.getElementById(UI.id_menu_assets_header);
    }

    public static get menu_assets_content(): HTMLElement {
        return <HTMLElement>document.getElementById(UI.id_menu_assets_content);
    }

    public static get menu_assets_content_css(): CssElement {
        return new CssElement(UI.menu_assets_content);
    }

    public static set expanded(is_expanded: boolean) {
        if (is_expanded) {
            document.getElementById("menu_assets_header_chevron").classList.remove("glyphicon-chevron-right")
            document.getElementById("menu_assets_header_chevron").classList.add("glyphicon-chevron-down")
        } else {
            document.getElementById("menu_assets_header_chevron").classList.remove("glyphicon-chevron-down")
            document.getElementById("menu_assets_header_chevron").classList.add("glyphicon-chevron-right")
        }
        UI.menu_assets_content_css.visibility = is_expanded;
    }
    public static get expanded(): boolean {
        return UI.menu_assets_content_css.visibility;
    }
}

function build_and_append_child_menu_item(category: Category, ul: HTMLUListElement): boolean {

    let floor_assets = get_state().assets.get_assets_on_floor(get_state().id_floor)

    if (floor_assets.get_assets_by_category(category).length === 0) {
        return false;
    }

    let count = floor_assets.get_assets_by_category(category).length;
    if (count === 0) {
        return false;
    }

    let is_expanded: boolean = expanded_categories.includes(category.id_category);

    let menu_idem_id: string = `id_asset__${category.id_category.value}`

    var html = `<li style='padding: 2px; padding-left: 15px; border-radius: 0px' class='list-group-item clearfix' >
  <span >
  <a href='#' id='${menu_idem_id}' class='waves-effect' id_category='${category.id_category.value}'>
  <img src='${category.icon}'  width='20' height='20' />
  <i class='material-icons'> ${category.label}</i>
  </a></span><span class='badge'>${count}</span>
  </li>`

    //    let li: HTMLLIElement = $.parseHTML(html)[0];
    let li: HTMLLIElement = li_from_html(html);
    let is_selected: boolean = get_state().menu_asset_categories_selected.includes(category.id_category);
    if (is_selected) {
        li.classList.add('selected');
    }
    append_menu_row(li);
    //    ul.appendChild(li);
    let anchor: HTMLAnchorElement = <HTMLAnchorElement>document.getElementById(menu_idem_id);
    anchor.onclick = onclick_asset_menu_item;
    return true;
}

function build_and_append_parent_menu_item(category: Category, ul: HTMLUListElement): boolean {

    if (!category.is_root_parent) {
        return false;
    }

    let is_expanded: boolean = expanded_categories.includes(category.id_category);

    let floor_assets = get_state().assets.get_assets_on_floor(get_state().id_floor)


    let asset_count: number = 0;
    get_state().categories.get_child_categories(category).forEach((child_cat: Category) => {
        asset_count += floor_assets.get_assets_by_category(child_cat).length;
    });

    if (asset_count === 0) {
        return false;
    }

    let menu_item_id: string = `category_parent__${category.id_category.value}`;
    let glyphicon: string = 'glyphicon  glyphicon-chevron-right'
    if (is_expanded) {
        glyphicon = 'glyphicon  glyphicon-chevron-down'
    }

    var html = `<li style='padding: 2px' class='list-group-item clearfix'>
      <span style='display: inline-block; width:175px;'>
      <a href='#' id='${menu_item_id}' class='waves-effect' id_category='${category.id_category.value}'>
      <span class='${glyphicon}' ></span>
      <i class='material-icons'>${category.label}</i>
      </a>
      </span><span class='badge'>${asset_count}</span>
      </li>
      `
    let li: HTMLLIElement = li_from_html(html);

    append_menu_row(li);
    //      ul.appendChild($.parseHTML(html)[0]);
    let anchor: HTMLAnchorElement = <HTMLAnchorElement>document.getElementById(menu_item_id);
    anchor.onclick = onclick_asset_menu_group;

    return true;
}

let menu_rows_count: number = 0;

function li_from_html(html: string): HTMLLIElement {
    return <HTMLLIElement>$.parseHTML(html.trim())[0];
}

function append_menu_row(li: HTMLLIElement): void {
    if (li) {
        let ul: HTMLUListElement = <HTMLUListElement>document.getElementById(UI.id_menu_assets_content_list)
        ul.appendChild(li);
        menu_rows_count++;
    }
}
function force_draw_assets_menu() {
    let state: State = get_state()
    let assets_selected: Id_category[] = state.menu_asset_categories_selected;
    $("#menu_assets_content_list").html("");  // remove all assets from the menu before building the menu.
    let ul: HTMLUListElement = <HTMLUListElement>document.getElementById('menu_assets_content_list')

    menu_rows_count = 0;
    let top_level_categories: Category[] = get_state().categories.top_level_categories;
    top_level_categories.sort(category_sort);

    top_level_categories.forEach((parent_category: Category) => {
        if (build_and_append_parent_menu_item(parent_category, ul)) {
            if (expanded_categories.includes(parent_category.id_category)) {
                let child_categories: Category[] = get_state().categories.get_child_categories(parent_category)
                child_categories.sort(category_sort);

                child_categories.forEach((child_category: Category) => {
                    if (build_and_append_child_menu_item(child_category, ul)) {
                    }
                })
            }
        }
    });

    if (menu_rows_count > 0) {
        let html: string = `
        
        <li class=' list-group-item ' style='padding: 2px' ><a href='#' id='assets_menu_selectall'   ><span class= 'glyphicon glyphicon-check'    ></span>&nbsp;Select All</a></li>
        
        `;
        append_menu_row(li_from_html(html))
        document.getElementById("assets_menu_selectall").onclick = onclick_select_all;

        html = `<li class=" list-group-item " style="padding: 2px" ><a href="#" id="assets_menu_clear"   ><span class= "glyphicon glyphicon-unchecked"></span>&nbsp; Clear All</a></li>`
        append_menu_row(li_from_html(html))
        document.getElementById("assets_menu_clear").onclick = onclick_clear_all;

    }
    if (!Configuration.read_only_mode) {
        let html: string = `<li class=" list-group-item " style="padding: 2px" >
        <a href="#" id="assets_menu_new"><span class= "glyphicon glyphicon glyphicon-plus"></span>&nbsp;Create a new asset</a>
        </li>
        `
        append_menu_row(li_from_html(html))

        document.getElementById("assets_menu_new").onclick = onclick_create_asset;
    }

    if (menu_rows_count == 0) {
        new CssElement(UI.menu_assets_header).visibility = false;
    }
    else {
        new CssElement(UI.menu_assets_header).visibility = true;
    }
}

export function draw_assets_menu() {
    if (!Configuration.assets_feature_enabled) {
        return;
    }
    if (did_any_change([Keys.KEY_STATE_FIRST_RUN])) {

        let menu_assets_container_html: string = `
        <a class="btn btn-primary" 
        style="  padding:2px;   background-color: #000;    border-color: #000  " 
        href="#" 
        id="${UI.id_menu_assets_header}">
            <span class="glyphicon  glyphicon-chevron-down" id="${UI.id_menu_assets_header_chevron}"></span> Assets
        </a>
        
        <div class="collapse in" id="${UI.id_menu_assets_content}">
            <div class="card card-block">
                <ul id="${UI.id_menu_assets_content_list}" class="list-group" style="padding: 2px"></ul>
            </div>
        </div>
        `

        UI.menu_assets_container.innerHTML = menu_assets_container_html;
        UI.menu_assets_header.onclick = onclick_assets_menu_header;
    }
    if (did_any_change([Keys.MENU_ASSETS_EXPANDED, Keys.KEY_STATE_FIRST_RUN])) {
        UI.expanded = get_state().menu_assets_expanded;
    }
    // if the menu assets content changed, redraw the assets menu
    if (did_any_change([Keys.KEY_STATE_FIRST_RUN, Keys.MENU_ASSETS_SELECTED,
    Keys.DATA_ASSETS, Keys.ID_FLOOR, Keys.MENU_ASSETS_CONTENT])) {
        force_draw_assets_menu();
    }
}

function onclick_select_all() {
    dispatch_action(Action.toggle_all_asset_categories(true));
}

function onclick_clear_all() {
    dispatch_action(Action.toggle_all_asset_categories(false));
}

function onclick_create_asset() {
    Dispatcher.dispatch(Actions.SET_ADD_ASSET_STATE, true)
}

function onclick_assets_menu_header(this: HTMLElement, ev: MouseEvent) {
    let expanding: boolean = !(new CssElement(UI.menu_assets_content).visibility); // !(.style.visibility === "visible");
    Cookie.write_bool(Keys.MENU_ASSETS_EXPANDED, expanding);
    dispatch_action(Action.set_menu_assets_expanded(expanding));//Action.set_key_boolean(Keys.MENU_ASSETS_EXPANDED, expanding));
}

function onclick_asset_menu_group(this: HTMLElement, ev: MouseEvent) {
    let target: EventTarget = ev.currentTarget;
    let id_category: Id_category = Id_category.wrap(Number.parseInt(this.getAttribute('id_category')));
    if (expanded_categories.includes(id_category)) {
        expanded_categories = expanded_categories.filter(function (item) {
            return item !== id_category;
        })
    } else {
        expanded_categories.push(id_category);
    }
    force_draw_assets_menu();
}

function onclick_asset_menu_item(this: HTMLElement, ev: MouseEvent) {
    let id_category: Id_category = Id_category.wrap(this.getAttribute('id_category'))
    let is_selected: boolean = get_state().menu_asset_categories_selected.includes(id_category);
    dispatch_action(Action.toggle_asset_category(id_category, !is_selected));
}



// WEBPACK FOOTER //
// ./src/ts/ui/menu/AssetsMenu.ts